import React from "react";
import {observable} from "mobx";

export default class ImportacaoDocsImportarStore {
    @observable listaArquivos;
    @observable listaMsgs;

    @observable salvando;
    @observable excluindo;
    @observable aguardandoSalvar;
    @observable achouErro;
    indexComProblemas;

    constructor(service) {
        this.listaArquivos = [];
        this.listaMsgs = [false];

        this.salvando = false;
        this.excluindo = false;
        this.aguardandoSalvar = false;
        this.achouErro = false;
        this.indexComProblemas = [];

        this.service = service;
    };

    guarda = (event, blId, protocoloId) => {
        let arquivos = _.map(event.target.files);
        arquivos.map(arquivo => {
            this.listaArquivos.push({
                fileData: arquivo,
                extensao: arquivo.type,
                numDoc: null,
                exigeCPF: false,
                dscArquivo: arquivo.name.replace(/[^a-zA-Z0-9\.]/g, ""),
                blId: blId,
                protocoloId: protocoloId,
                tipoDocId: false
            });
        });
    };    

    envia = (callback, fecharModal) => {
        this.achouErro = false;
        this.aguardandoSalvar = true;
        this.indexComProblemas = [];

        this.salvando = [];
        Promise.all([
            this.listaArquivos.map((arquivo, x) => {
                this.salvando.push({finalizado: false});
                let data = new FormData();
                data.append('file', arquivo.fileData);
                return this.service.salvarDocumento(data, arquivo).then(response => {
                    this.salvando[x].finalizado = true;
                    if (response) {
                        if (!response.data.Sucesso) {
                            this.incluiErro(x, response.data.MensagemErro);
                        }
                    } else {
                        this.incluiErro(x, "Ocorreu um problema");
                    }
                }).catch(error => {
                    console.log(error)
                    this.achouErro = true;
                    this.aguardandoSalvar = false;
                })
            }),
        ]).then(() => {
            this.validacao(callback, fecharModal);
        }).catch((error) => { console.log(error); this.aguardandoSalvar = false; });
    };

    incluiErro = (x, msg) => {
        this.achouErro = true;
        this.listaMsgs[x] = msg;
        this.indexComProblemas.push(x);
    };

    validacao = (callback, fecharModal) => {
        if (this.salvando.find(s => s.finalizado===false)) {
            setTimeout(function() {
                this.validacao(callback, fecharModal);
            }.bind(this), 1000);
        } else {
            this.aguardandoSalvar = false;
            if (!this.achouErro) {
                callback();
                fecharModal();
            } else {
                this.listaArquivos = this.listaArquivos.filter((a, x) => {
                    return !(this.indexComProblemas.indexOf(x)===-1);
                });
            }
        }
    };

    excluirArquivoAnexo = async (index) => {
        this.excluindo = true;
        if (this.listaArquivos && this.listaArquivos.length > 0)
        {
            await this.listaArquivos.splice(index,1);
        }
        this.excluindo =false;
    }

    setTipo = (event, x) => {
        if (event)
            this.listaArquivos[x].tipoDocId = event;
        else
            this.listaArquivos[x].tipoDocId = false;
    };
    
    setNumDoc = (event, x) => {
        if (event)
            this.listaArquivos[x].numDoc = event.target.value !="" ? event.target.value: null;
        else
            this.listaArquivos[x].numDoc = null;
    };

};


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/stores/ImportacaoDocsImportarStore.js